import { Injectable } from '@angular/core';
import { IAdapter } from 'src/app/models';
import { EntryCode } from 'src/app/models/domain';
import { YPMNOTIFICATIONSRVItems } from 'src/generated-clients/notification';

@Injectable({
  providedIn: 'root',
})
export class EntryCodeAdapter implements IAdapter<EntryCode, YPMNOTIFICATIONSRVItems> {
  public adaptToDomain(item: YPMNOTIFICATIONSRVItems): EntryCode {
    return new EntryCode(item.partOfObject ?? '', item.causeShortText ?? '');
  }
}
